<header class="page-header">
  <div class="user-options">
    <!-- Enviar mensaje (dropdown) -->
    <tui-hosted-dropdown
      tuiDropdownLimitWidth="auto"
      [content]="sending_options"
      [(open)]="dropdownOpen"
      size="m"
    >
      <button
        tuiButton
        tuiHostedDropdownHost
        class="sending-button"
        type="button"
        size="m"
        appearance="secondary-button"
        [disabled]="!selectAll && selectedRows().length === 0"
      >
        {{ "service_manager.pending_service.send_message" | translate }}
      </button>
    </tui-hosted-dropdown>

    <!-- Nuevo servicio -->
    <button
      tuiButton
      type="button"
      size="m"
      appearance="primary-button"
      icon="tuiIconPlusCircleLarge"
      (click)="openDuplicateModal()"
    >
      {{ "service_manager.pending_service.button_new" | translate }}
    </button>
  </div>
</header>

<!-- ▒▒▒  CONTENEDOR PRINCIPAL  ▒▒▒ -->
<section class="table-body">
  <!-- ░░  Encabezado lista + Export  ░░ -->
  <div class="table-body-head mb-3">
    <!-- Exportar (dropdown) -->
    <div class="export-container">
      <span class="table-title-filter">
        {{ "service_manager.pending_service.filter_label" | translate }}
        ({{ totalItems }})
      </span>

      <tui-hosted-dropdown
        tuiDropdownLimitWidth="auto"
        [content]="download_options"
        [(open)]="open"
      >
        <button
          tuiHostedDropdownHost
          class="export-button"
          type="button"
          [disabled]="isLoading || displayedRows.length === 0"
        >
          <img
            src="assets/icons/download-Icon.svg"
            alt="download"
            class="img-icon"
          />
          {{ "service_manager.pending_service.export_text" | translate }}
        </button>
      </tui-hosted-dropdown>
    </div>
  </div>

  <!-- ░░  FILTROS  ░░ -->
  <form
    class="filters responsive-filters mb-3"
    [formGroup]="filtersForm"
    tuiGroup
  >
    <!-- Search -->
    <div class="filter-item search">
      <img [src]="searchIcon" alt="search" class="search__icon" />
      <input
        class="search__input"
        formControlName="search"
        type="text"
        [placeholder]="
          'service_manager.pending_service.search_text' | translate
        "
        [disabled]="isInitializing || (isLoading && !isSearching)"
        aria-label="search"
        autocomplete="off"
      />

      <div *ngIf="isSearching" class="search__spinner" aria-hidden="true">
        <tui-loader size="s"></tui-loader>
      </div>
    </div>

    <!-- Date-range  -->
    <tui-input-date-range
      class="filter-item"
      formControlName="dateRange"
      tuiMode="onDark"
      tuiTextfieldSize="s"
      [tuiTextfieldLabelOutside]="true"
      [disabled]="isLoading"
    >
      {{ "service_manager.pending_service.date_range_placeholder" | translate }}
    </tui-input-date-range>

    <!-- Zone -->
    <ng-select
      class="filter-item custom_select"
      formControlName="zones"
      [items]="zones"
      bindLabel="zoneName"
      [loading]="isInitializing"
      bindValue="zoneId"
      [clearable]="true"
      [multiple]="true"
      [disabled]="isLoading || isInitializing"
      placeholder="{{
        'service_manager.pending_service.zone_input' | translate
      }}"
    ></ng-select>

    <!-- Products -->
    <ng-select
      class="filter-item custom_select"
      formControlName="products"
      [bindLabel]="'ProductLabel'"
      [bindValue]="'ProductKey'"
      [loading]="isInitializing"
      [items]="products"
      [multiple]="true"
      [clearable]="true"
      [disabled]="isLoading || isInitializing"
      placeholder="{{
        'service_manager.pending_service.products_input' | translate
      }}"
    ></ng-select>

    <!-- Clients -->
    <ng-select
      class="filter-item custom_select"
      formControlName="clients"
      [items]="allClients"
      bindLabel="businessName"
      [loading]="isInitializing"
      bindValue="businessName"
      [multiple]="false"
      [clearable]="true"
      [disabled]="isLoading || isInitializing"
      placeholder="{{
        'service_manager.pending_service.clients_input' | translate
      }}"
    ></ng-select>

    <!-- Communication: temporalmente oculto hasta que el backend lo soporte -->

    <!--

      <ng-select
      class="filter-item custom_select communication_select"
      formControlName="communication"
      [items]="commCountersSorted"
      bindLabel="label"
      bindValue="key"
      [multiple]="true"
      [appendTo]="'body'"
      [searchable]="false"
      [clearable]="true"
      placeholder="{{
        'service_manager.pending_service.communication_filter' | translate
      }}"
    >
      <ng-template ng-option-tmp let-item="item">
        <div class="option-item">
          <div class="option-left">
            <span class="comm-dot" [style.background]="item.color"></span>
            <span class="option-text">{{ item.label }}</span>
          </div>
          <span class="badge">{{ item.value }}</span>
        </div>
      </ng-template>

      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label">
          <span class="comm-dot" [style.background]="item.color"></span>
          {{ item.label }}
          <span class="ng-value-icon" (click)="clear(item)">×</span>
        </span>
      </ng-template>
    </ng-select>

    <ng-container *ngIf="false">
      ...communication control...
    </ng-container>
    -->
  </form>

  <!-- Loader -->
  <div class="loader-cell" *ngIf="isLoading">
    <tui-loader size="l"></tui-loader>
  </div>

  <!-- ░░  TABLA  ░░ -->
  <div class="table-responsive" *ngIf="!isLoading && displayedRows.length">
    <table tuiTable size="l" class="w-100" [columns]="columns">
      <!-- ENCABEZADOS -->
      <thead>
        <tr tuiThGroup>
          <th
            *tuiHead="'selected'"
            class="th-style"
            tuiTh
            [sticky]="true"
            [sorter]="null"
          >
            <tui-checkbox
              [(ngModel)]="selectAll"
              [disabled]="!canSelectAny"
              class="select-all-checkbox"
            ></tui-checkbox>
          </th>

          <th
            *tuiHead="'licensePlate'"
            tuiTh
            (click)="onSort('licensePlate')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.plate_input_table" | translate
            }}
          </th>

          <th
            *tuiHead="'time'"
            tuiTh
            (click)="onSort('startHour')"
            [sticky]="true"
          >
            {{ "service_manager.pending_service.hour_input_table" | translate }}
          </th>

          <th
            *tuiHead="'orderHash'"
            tuiTh
            (click)="onSort('orderHash')"
            [sticky]="true"
          >
            {{ "service_manager.pending_service.hash_input_table" | translate }}
          </th>

          <th
            *tuiHead="'zone'"
            tuiTh
            (click)="onSort('zoneName')"
            [sticky]="true"
          >
            {{ "service_manager.pending_service.zone_input_table" | translate }}
          </th>

          <th *tuiHead="'date'" tuiTh (click)="onSort('formattedDate')">
            {{ "service_manager.pending_service.date_input_table" | translate }}
          </th>

          <th
            *tuiHead="'product'"
            tuiTh
            (click)="onSort('productName')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.product_input_table" | translate
            }}
          </th>

          <!-- Category -->
          <ng-container *ngIf="shouldShowCategoryColumn()">
            <th *tuiHead="'category'" tuiTh (click)="onSort('category')" [sticky]="true">
              {{"service_manager.pending_service.category" | translate }}
            </th>
          </ng-container>
          
          <th
            *tuiHead="'isAPoolService'"
            tuiTh
            (click)="onSort('isAPoolService')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.isAPoolService_input_table"
                | translate
            }}
          </th>

          <th
            *tuiHead="'topping'"
            tuiTh
            (click)="onSort('toppingNames')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.toppings_input_table" | translate
            }}
          </th>

          <th
            *tuiHead="'client'"
            tuiTh
            (click)="onSort('clientName')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.client_input_table" | translate
            }}
          </th>

          <th *tuiHead="'communication'" tuiTh [sticky]="true">
            {{
              "service_manager.pending_service.communication_input_table"
                | translate
            }}
          </th>

          <th
            *tuiHead="'pickup'"
            tuiTh
            (click)="onSort('originAddress')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.pickup_address_input_table"
                | translate
            }}
          </th>

          <th
            *tuiHead="'delivery'"
            tuiTh
            (click)="onSort('destinationAddress')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.delivery_input_table" | translate
            }}
          </th>

          <th
            *tuiHead="'driver'"
            tuiTh
            (click)="onSort('driversNameDisplay')"
            [sticky]="true"
          >
            {{ "service_manager.pending_service.column_driver" | translate }}
          </th>

          <th
            *tuiHead="'comment'"
            tuiTh
            (click)="onSort('additionalInformation')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.comments_input_table" | translate
            }}
          </th>

          <th
            *tuiHead="'totalPrice'"
            tuiTh
            (click)="onSort('totalPrice')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.totalPrice_input_table"
                | translate
            }}
          </th>

          <th
            *tuiHead="'hasDeliveryNote'"
            tuiTh
            (click)="onSort('hasDeliveryNote')"
            [sticky]="true"
          >
            {{
              "service_manager.pending_service.delivery_note_input_table"
                | translate
            }}
          </th>

          <th
            *tuiHead="'actions'"
            tuiTh
            [sticky]="true"
            class="actions-text"
            [sorter]="null"
          >
            {{ "service_manager.pending_service.column_actions" | translate }}
          </th>
        </tr>
      </thead>

      <!-- FILAS -->
      <tbody tuiTbody *ngIf="displayedRows.length && !isLoading; else noData">
        <tr tuiTr *ngFor="let row of displayedRows; trackBy: rowTrack">
          <!-- Selección -->
          <td *tuiCell="'selected'" tuiTd class="select-cell">
            <ng-container *ngIf="hasCommunication(row)">
              <tui-checkbox [(ngModel)]="row.selected"></tui-checkbox>
            </ng-container>
          </td>

          <!-- Matrícula + orden -->
          <td *tuiCell="'licensePlate'" tuiTd>
            <div class="vertical-align">
              <span tuiTitle>{{ row.licensePlate }}</span>
            </div>
          </td>

          <!-- Horario -->
          <td *tuiCell="'time'" tuiTd>
            <span tuiTitle>{{ row.startHour }} - {{ row.endHour }}</span>
          </td>

          <!-- Order Hash -->
          <td *tuiCell="'orderHash'" tuiTd>
            <span tuiTitle>{{ row.orderHash }}</span>
          </td>

          <!-- Zona -->
          <td *tuiCell="'zone'" tuiTd>
            <span tuiTitle>{{ row.zoneName }}</span>
          </td>

          <!-- Fecha -->
          <td *tuiCell="'date'" tuiTd>
            <span tuiTitle>{{ row.formattedDate }}</span>
          </td>

          <!-- Producto -->
          <td *tuiCell="'product'" tuiTd>
            <span tuiTitle>{{ translateProduct(row.productName) }}</span>
          </td>
          
          <!-- Category -->
          <ng-container *ngIf="shouldShowCategoryColumn()">
            <td *tuiCell="'category'" tuiTd>
              <ng-container *ngIf="row.category as cat; else noCat">
                {{ cat }}
              </ng-container>
              <ng-template #noCat>—</ng-template>
            </td>
          </ng-container>

          <td *tuiCell="'isAPoolService'" tuiTd>
            <tui-badge
              [size]="'m'"
              class="badge-pool-service"
              [status]="row.isAPoolService ? 'success' : 'error'"
              [value]="
                row.isAPoolService
                  ? ('service_manager.pending_service.in_pool' | translate)
                  : ('service_manager.pending_service.not_in_pool' | translate)
              "
              size="s"
            ></tui-badge>
          </td>


          <!-- Toppings -->
          <td *tuiCell="'topping'" tuiTd>
            <span tuiTitle *ngIf="row.toppingNames.length; else noTop">
              <ng-container *ngFor="let top of row.toppingNames">
                {{ top }}<br />
              </ng-container>
            </span>
            <ng-template #noTop>—</ng-template>
          </td>

          <!-- Cliente -->
          <td *tuiCell="'client'" tuiTd>
            <span tuiTitle>{{ row.clientName }}</span>
          </td>

          <!-- Comunicación -->
          <td *tuiCell="'communication'" tuiTd>
            <!-- Si existe canal, pinta los iconos -->
            <ng-container
              *ngIf="hasCommunication(row); else noComm"
              [ngSwitch]="true"
            >
              <img
                *ngIf="row.communication?.whatsAppAnswered"
                src="assets/icons/communication-icons/answered.svg"
                alt="answered"
                tuiHint="{{ 'communication.WHATSAPP_ANSWERED' | translate }}"
              />
              <img
                *ngIf="row.communication?.whatsAppWaitingAnswer"
                src="assets/icons/communication-icons/waiting_answer.svg"
                alt="waiting"
                tuiHint="{{ 'communication.WHATSAPP_WAITING' | translate }}"
              />
              <img
                *ngIf="row.communication?.whatsAppErrorSending"
                src="assets/icons/communication-icons/error_sending.svg"
                alt="wa-error"
                tuiHint="{{ 'communication.WHATSAPP_ERROR' | translate }}"
              />
              <img
                *ngIf="row.communication?.whatsAppNotAnsweredInTime"
                src="assets/icons/communication-icons/not_answered_in_time.svg"
                alt="wa-no-answer"
                tuiHint="{{ 'communication.WHATSAPP_NO_ANSWER' | translate }}"
              />
              <img
                *ngIf="row.communication?.smsSent"
                src="assets/icons/communication-icons/sms_sent.svg"
                alt="sms"
                tuiHint="{{ 'communication.SMS_SENT' | translate }}"
              />
              <img
                *ngIf="row.communication?.smsSendingError"
                src="assets/icons/communication-icons/error_sending_sms.svg"
                alt="sms-error"
                tuiHint="{{ 'communication.SMS_ERROR' | translate }}"
              />
            </ng-container>

            <!-- Fallback cuando NO hay ningún canal -->
            <ng-template #noComm>
              <span> - </span>
            </ng-template>
          </td>
          <!-- Pickup -->
          <td *tuiCell="'pickup'" tuiTd>
            <span tuiTitle>{{ row.originAddress }}</span>
          </td>

          <!-- Delivery -->
          <td *tuiCell="'delivery'" tuiTd>
            <span tuiTitle>{{ row.destinationAddress }}</span>
          </td>

          <!-- Driver -->
          <td *tuiCell="'driver'" tuiTd>
            <ng-container *ngIf="row.driversName?.length; else noDriverNames">
              <div class="driver-lines" tuiTitle>
                <span class="driver-line" *ngFor="let driverName of row.driversName">
                {{ driverName }}
                </span>
              </div>
            </ng-container>
            <ng-template #noDriverNames>
              <span class="driver-unassigned-chip" tuiTitle>
                {{ "service_manager.pending_service.unassigned" | translate }}
              </span>
            </ng-template>
          </td>

          <!-- Comentarios -->
          <td *tuiCell="'comment'" tuiTd>
            <span tuiTitle *ngIf="row.additionalInformation; else noComment">
              {{ row.additionalInformation }}
            </span>
            <ng-template #noComment>
              <span class="no-comments"> - </span>
            </ng-template>
          </td>

          <!-- Precio -->

          <td *tuiCell="'totalPrice'" tuiTd>
            <span tuiTitle>
              <ng-container
                *ngIf="
                  row?.totalPrice != null && row?.currencySymbol;
                  else dash
                "
              >
                {{ row.totalPrice | number : "1.2-2" }} {{ row.currencySymbol }}
              </ng-container>
              <ng-template #dash>-</ng-template>
            </span>
          </td>

          <td *tuiCell="'hasDeliveryNote'" tuiTd>
            <div class="delivery-note-cell">
              <ng-container *ngIf="row.hasDeliveryNote; else noDeliveryNote">
                <span class="delivery-note-yes">
                  {{ 'common.yes' | translate }}
                </span>
              </ng-container>
              <ng-template #noDeliveryNote>
                <span class="delivery-note-no">
                  {{ 'common.no' | translate }}
                </span>
              </ng-template>
            </div>
          </td>

          <!-- Acciones -->
          <td *tuiCell="'actions'" tuiTd>
            <ng-container *ngIf="!isRowLoading(row.orderHash); else loadingTpl">
              <button
                tuiIconButton
                appearance="link"
                icon="tuiIconEye"
                size="xs"
                (click)="viewDetail(row)"
              ></button>
              <button
                tuiIconButton
                appearance="link"
                icon="tuiIconEdit2"
                size="xs"
                (click)="openModalEditService(row)"
              ></button>
            </ng-container>

            <ng-template #loadingTpl>
              <tui-loader size="xs"></tui-loader>
            </ng-template>
          </td>
        </tr>
      </tbody>
      <!-- SIN DATOS -->
      <ng-template #noData>
        <tbody tuiTbody>
          <tr tuiTr>
            <td tuiTd [attr.colspan]="shouldShowCategoryColumn() ? 18 : 17" class="text-center">
              {{ "service_manager.pending_service.no_data" | translate }}
            </td>
          </tr>
        </tbody>
      </ng-template>
      <!-- loader -->
    </table>
  </div>

  <div
    class="no-results py-4 text-center fw-medium"
    *ngIf="!isLoading && !displayedRows.length"
  >
    {{ "service_manager.pending_service.no_data_filters" | translate }}
  </div>

  <!-- ░░  Paginación  ░░ -->
  <footer
    class="table-pagination mt-2"
    *ngIf="!isLoading && displayedRows.length"
  >
    <tui-pagination
      [index]="pageIndex"
      [length]="totalPages"
      (indexChange)="onChangePage($event)"
    ></tui-pagination>
  </footer>
</section>

<!-- ▒▒▒  TEMPLATE: Export opciones  ▒▒▒ -->
<ng-template #download_options>
  <div class="download-menu">
    <h3 class="export-title">
      {{ "service_manager.pending_service.complement_export_text" | translate }}
    </h3>

    <div class="checkbox-container">
      <div class="checkbox-container-row">
        <tui-checkbox [(ngModel)]="exportXlsx"></tui-checkbox>
        <span class="export-body-label">Excel (.xlsx)</span>
      </div>

      <div class="checkbox-container-row">
        <tui-checkbox [(ngModel)]="exportCsv"></tui-checkbox>
        <span class="export-body-label"> CSV (.csv) </span>
      </div>
    </div>

    <button
      type="button"
      class="export-button-menu mt-12"
      (click)="exportSelected()"
      [disabled]="(!exportCsv && !exportXlsx) || exportInProgress"
      aria-live="polite"
    >
      <div *ngIf="!exportInProgress">
        <img src="assets/icons/download-Icon.svg" alt="" class="img-icon" />
        <span>{{
          "service_manager.pending_service.export_text" | translate
        }}</span>
        ({{ exportFormatCount }})
      </div>
      <div >
        <span *ngIf="exportInProgress" aria-hidden="true">
          <tui-loader size="xs"></tui-loader>
        </span>
      </div>
    </button>
  </div>
</ng-template>

<!-- ▒▒▒  TEMPLATE: Enviar mensaje  ▒▒▒ -->
<ng-template #sending_options>
  <div class="sending-menu">
    <h3 class="export-title mb-2">
      {{ "service_manager.pending_service.send_message" | translate }}
    </h3>

    <div class="radio-list-container">
      <tui-radio-list
        [(ngModel)]="sendingMethod"
        [items]="['WhatsApp', 'SMS']"
      ></tui-radio-list>
    </div>

    <div class="export-button-menu-container">
      <button
        class="export-button-menu"
        type="submit"
        (click)="openSendMessage()"
      >
        <ng-container>
          {{ "service_manager.pending_service.send_message" | translate }}
        </ng-container>
      </button>
    </div>
  </div>
</ng-template>
